import { Flex, Tooltip, Typography } from "antd";
import { DropdownButton, WhiteBoxBlock } from "ui";
import style from "./template.module.css";

import { AddTemplatesFileBtn } from "./AddTemplatesFileBtn";
import { dateFormat, useRequestWithNotify } from "utils";
import { TTemplate } from "interfaces/templates";
import { TemplatesCodeBtn } from "./TemplatesCodeBtn";
import { TEMPLATE_FORMAT_ENUM } from "interfaces";
import { observer } from "mobx-react-lite";
import { useStores } from "stores";

import styles from "./template.module.css";

type Props = {
  template: TTemplate;
};

export const TemplatesItem = observer(({ template }: Props) => {
  const { templates } = useStores();

  const { request, loading } = useRequestWithNotify({
    errorMsg: "Ошибка при скачивании документа",
    showErrorNotification: true,
  });

  const items = [
    {
      key: "default",
      label: "Скачать эталон",
      onClick: () => request(() => templates.downloadDefaultFile(template.type)),
    },
    {
      key: "rules",
      label: "Скачать текущую версию",
      onClick: () => request(() => templates.downloadFile(template.type)),
    },
  ];

  return (
    <WhiteBoxBlock className={`bg-basic-200 full-width ${style.templateBoxPadding}`}>
      <Flex justify="space-between" align="center">
        <Flex gap={1} vertical>
          <Typography.Text strong>
            {template.description}
            {template.format !== TEMPLATE_FORMAT_ENUM.SHEET && <TemplatesCodeBtn type={template.type} />}
          </Typography.Text>

          <div style={{ width: "150px" }}>
            <Tooltip title="Дата добавления">
              <Typography.Text className="text-description text-small">
                {dateFormat(template.templateFile.uploadedAt, true)}
              </Typography.Text>
            </Tooltip>
          </div>
        </Flex>

        <Flex vertical gap="small">
          <Flex>
            <AddTemplatesFileBtn
              type={template.type}
              tooltip="Загрузить документ"
              fn={({ file, type }) => templates.uploadFile(file, type ?? "")}
              onSuccess={() => templates.getTemplates()}
            />
            <DropdownButton className={styles.uploadDocBtn} items={items} disabled={loading} loading={loading} />
          </Flex>
        </Flex>
      </Flex>
    </WhiteBoxBlock>
  );
});
